import { SignUp } from "@clerk/clerk-react";
import { createFileRoute, Navigate } from "@tanstack/react-router";

/**
 * Route configuration for the sign-up page.
 * Accepts optional redirect search parameter to return users to their intended destination.
 * Uses catch-all route ($) to handle Clerk's authentication flow paths like /signup/sso-callback
 */
export const Route = createFileRoute("/signup")({
  validateSearch: (search: Record<string, unknown>) => ({
    redirect: (search.redirect as string) || "/document-upload",
  }),
  component: SignUpPage,
});

/**
 * Sign-up page component.
 * Renders Clerk's authentication UI for new user registration.
 * Redirects authenticated users to their intended destination.
 *
 * @returns Centered sign-up form
 */
function SignUpPage() {
  const { auth } = Route.useRouteContext();
  const { redirect } = Route.useSearch();

  // If user is already authenticated, redirect immediately
  if (auth.isAuthenticated) {
    return <Navigate to={redirect} />;
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#fafafa]">
      <SignUp
        routing="path"
        path="/signup"
        signInUrl="/signin"
        fallbackRedirectUrl={redirect}
      />
    </div>
  );
}
